export default __webpack_public_path__ + "static/media/postman.985dd1c0.svg";